import { useQuery } from '@tanstack/react-query';

import { businessPlanQueryKeys } from '../businessPlan-qk';
import { BusinessPlanApi } from '../businessPlan.api';
import { IGetUsersWithAccessParams } from '../types';

export const useGetAllAccessUsers = (params: IGetUsersWithAccessParams) => {
  return useQuery({
    queryKey: businessPlanQueryKeys.accessUsers(params.id),
    queryFn: () => BusinessPlanApi.getUsersWithAccess(params),
  });
};
